const isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
  navigator.userAgent &&
  navigator.userAgent.indexOf('CriOS') == -1 &&
  navigator.userAgent.indexOf('FxiOS') == -1;

if (isSafari) {
  document.body.classList.add('safari')
}

const isChromeIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) &&
  navigator.userAgent.indexOf('CriOS') > -1;

if (isChromeIOS) {
  document.body.classList.add('chrome-ios')
}

const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

if (isFirefox) {
	document.body.classList.add('firefox')
}
